import { AlphaRBoxIcon } from './AlphaRBoxIcon';

/**
 * author: GreenTurtwig
 * id 0089397E-6983-4161-9D06-77F3598119DD
 * name alpha-r-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-r-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetRBoxIcon = AlphaRBoxIcon;
export default AlphabetRBoxIcon